await S.import('@main');
await u.domready();

const headerSwiperInstance = new Swiper('.winner-header-swiper', {
  slidesPerView: 1.5,
  centeredSlides: true,
  spaceBetween: 8,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    768: {
      slidesPerView: 3,
      centeredSlides: false,
    },
    992: {
      slidesPerView: 5,
      centeredSlides: false,
    },
    1199: {
      slidesPerView: 6,
      centeredSlides: false,
    }
  }
});
